import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const guestAll: ApiFunc<`${typeof API.USER_GUEST_ALL}`, 'get'> = data =>
  instance.get(API.USER_GUEST_ALL, {
    params: data,
  })

export const guestList: ApiFunc<`${typeof API.USER_GUEST}`, 'get'> = data =>
  instance.get(API.USER_GUEST, {
    params: data,
  })
